module.exports = __webpack_public_path__ + "img/face.99f39db5.png";